"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegistrationTokenDto = /** @class */ (function () {
    function RegistrationTokenDto() {
    }
    return RegistrationTokenDto;
}());
exports.default = RegistrationTokenDto;
